export const PRELOADER_SHOW_INIT = 'PRELOADER_SHOW_INIT';
export const PRELOADER_SHOW_SUCCESS = 'PRELOADER_SHOW_SUCCESS';

export const showPreloader = () => ({
    type: PRELOADER_SHOW_INIT,
})

export const hidePreloader = () => ({
    type: PRELOADER_SHOW_SUCCESS,
})